import { isValid } from 'date-fns';

// import { SettingsTab } from './settingsSlice';

import { api } from '~constants';

export type SettingsTab =
  | 'system'
  | 'server'
  | 'network'
  | 'tech-options'
  | 'sub-tools'
  | 'check-in'
  | 'antennas'
  | 'fcc'
  | 'maintenance'
  | 'self-monitoring'
  | 'integrations';

export type SystemSettingsSection =
  | 'length-unit'
  | 'database-dump'
  | 'password'
  | 'user-inactive-days'
  | 'mfa'
  | 'show-ul-warning'
  | 'token-expiration'
  | 'auto-supervision'
  | 'smtp'
  | 'notification-template'
  | 'notifications'
  | 'incc-logs';

export type ServerSettingsSection =
  | 'server'
  | 'coordinate';

export type NetworkSettingsSection =
  | 'network'
  | 'instances'
  | 'tcp'
  | 'protocol';

export const getSettingsRequestConfig = (
  tab: SettingsTab = 'fcc'
): { url: string; title: string; handler: 'put' | 'patch' } => {
  switch (tab) {
    case 'tech-options':
      return { url: api.settings.techOptions, title: 'Tech Option', handler: 'put' };

    case 'sub-tools':
      return { url: api.settings.subTools, title: 'Subtools', handler: 'put' };

    case 'check-in':
      return { url: api.settings.checkIn, title: 'Check-in Grace', handler: 'put' };

    case 'integrations':
      return { url: api.settings.httpIntegration, title: 'HTTP Integration', handler: 'patch' };

    default:
      return { url: api.settings.callSign, title: 'FCC', handler: 'patch' };
  }
};

export const getSystemSettingsRequestConfig = (
  section: SystemSettingsSection = 'length-unit'
): { url: string; title: string; handler: 'put' | 'patch' | 'post' } => {
  switch (section) {
    case 'password':
      return { url: api.settings.password, title: 'Password Expiration', handler: 'patch' };

    case 'user-inactive-days':
      return { url: api.settings.userInactivity, title: 'User Inactivity', handler: 'patch' };

    case 'mfa':
      return { url: api.settings.mfa, title: 'Two-Factor Authentication', handler: 'patch' };

    case 'show-ul-warning':
      return { url: api.settings.ulWarning, title: 'Show UL Speaker Warning', handler: 'patch' };

    case 'token-expiration':
      return { url: api.settings.tokenExpiration, title: 'Token Expiration Period', handler: 'patch' };

    case 'smtp':
      return { url: api.settings.smtp, title: 'SMTP Server', handler: 'patch' };

    case 'notification-template':
      return { url: api.settings.notificationsSettings, title: 'Notifications Template', handler: 'put' };

    case 'notifications':
      return { url: api.system.orphanNotifications.all, title: 'Instance Level Notification', handler: 'patch' };

    default:
      return { url: api.settings.lengthUnit, title: 'Units of measure', handler: 'patch' };
  }
};

export const getServerSettingsRequestConfig = (
  section: ServerSettingsSection = 'server'
): { url: string; title: string; handler: 'put' | 'patch' } => {
  switch (section) {
    case 'coordinate':
      return { url: api.settings.coordinate, title: 'Coordinate', handler: 'patch' };

    default:
      return { url: api.settings.server, title: 'Server', handler: 'patch' };
  }
};

export const getNetworkSettingsRequestConfig = (
  section: NetworkSettingsSection = 'network'
): { url: string; title: string; handler: 'put' | 'patch' | 'get' } => {
  switch (section) {
    case 'instances':
      return { url: api.settings.instances, title: 'Instances', handler: 'patch' };

    case 'tcp':
      return { url: api.settings.tcp.status, title: 'TCP', handler: 'get' };

    case 'protocol':
      return { url: api.settings.protocol, title: 'Protocol', handler: 'get' };

    default:
      return { url: api.settings.network, title: 'Network', handler: 'put' };
  }
};

export const validateDateAndTimeFields = (date, time) =>
  date !== time && isValid(new Date(date)) && isValid(new Date(time));
